import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { IconButton } from '@mui/material'
import SendIcon from '@mui/icons-material/Send'

const InputContainer = styled.div`
  margin-top: auto;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding: 16px 20px;
  background: #fff;
`

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${({ theme }) => theme.colors.backgroundColor};
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 8px;
  padding: 8px 12px;

  @media (max-width: 768px) {
    gap: 8px;
    padding: 4px 8px;
  }
`

const TextArea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  padding: 4px 0;
  resize: none;
  background: transparent;
  font-family: inherit;
  min-height: 24px;
  max-height: 120px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey[200]};
  }

  &:disabled {
    color: #999;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 10px 4px;
    min-height: 44px;
  }
`

const SendButton = styled(IconButton)`
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.grey[200] : theme.colors.primary} !important;
  padding: 8px !important;
`

const GuruInput = ({ onSend, disabled, placeholder, autoFocus = false }) => {
  const [value, setValue] = useState('')
  const textareaRef = useRef(null)

  useEffect(() => {
    if (autoFocus && textareaRef.current && !disabled) {
      textareaRef.current.focus()
    }
  }, [autoFocus, disabled])

  const handleSend = () => {
    if (!value.trim() || disabled) return
    onSend(value.trim())
    setValue('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <InputContainer>
      <InputWrapper>
        <TextArea
          data-tour-id='guru.input'
          ref={textareaRef}
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          placeholder={placeholder || 'Ask Guru a question...'}
          rows={1}
        />
        <SendButton data-tour-id='guru.send' onClick={handleSend} disabled={disabled || !value.trim()}>
          <SendIcon />
        </SendButton>
      </InputWrapper>
    </InputContainer>
  )
}

export default GuruInput
